// initial state
const state = () => ({
    notifications: [],
    notificationsAdmin: []
})

// getters
const getters = {
}

// actions
const actions = {
    getNotifications: async ({ commit }) => {
        return await axios.get('notification').then(({ data }) => {
            commit('setNotifications', data);
            return data;
        }).catch((error) => {
            throw error.response?.data;
        });
    },

    getNotificationsAdmin: async ({ commit }) => {
        return await axios.get('notification?all=true&limit=10').then(({ data }) => {
            commit('setNotificationsAdmin', data);
            return data;
        }).catch((error) => {
            throw error.response?.data;
        });
    },

    storeNotification: async ({ state, commit }, inputData) => {
        console.log('storeNotification', inputData.notification, inputData.selectedUsers);
        inputData.notification.users = inputData.selectedUsers;
        let { data } = await axios.post('notification', inputData.notification);
        // commit('setNotifications', data);
    },

    markReadNotification: async ({ state, commit }, notification) => {
        console.log('markRead', notification);
        let { data } = await axios.post('notification/' + notification.id + '/mark-as-read', notification);
    },

    trashNotification: async ({ state, commit }, notification) => {
        console.log('trash', notification);
        let { data } = await axios.post('notification/' + notification.id + '/trash', notification);
    }
}

// mutations
const mutations = {
    setNotifications(state, payload) {
        state.notifications = payload;
    },

    newNotification(state, payload) {
        // Put the new notification in the beginning of the array
        state.notifications.unshift(payload);
    },

    setNotificationsAdmin(state, payload) {
        state.notificationsAdmin = payload;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
